
import PropTypes from 'prop-types'
import { Component } from 'react'

import { EsasCategoryCodes } from '../../../../../lib/Codes'
import {
  SelectInput,
  SliderInput,
  makeAutobindedInput
} from '../../../../shared/FormBuilder'

class EsasSlideSelect extends Component {
  constructor (props) {
    super(props)
    this.valueCheck = this.valueCheck.bind(this)
  }

  valueCheck () {
    const { categoryState, ratingState } = this.props
    if (ratingState && !categoryState) {
      return true
    }
    return false
  }

  render () {
    const { categoryName, ratingName, header, ratingState } = this.props
    return (
      <div className='row middle-xs'>
        <div className='col-xs-12'>
          <h2>{header}</h2>
        </div>
        <div className='col-xs-4'>
          <SelectInput
            name={categoryName}
            noSort
            options={EsasCategoryCodes}
            label='Category'
            required={this.valueCheck()}
          />
        </div>
        <div
          className='col-xs-2'
          style={{ paddingTop: '40px' }}
        >
          Rating:
          {' '}
          {ratingState}
        </div>
        <div className='col-xs-5'>
          <SliderInput name={ratingName} />
        </div>
      </div>
    )
  }
}

EsasSlideSelect.propTypes = {
  categoryName: PropTypes.string.isRequired,
  ratingName: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  ratingState: PropTypes.any,
  categoryState: PropTypes.any
}

export default makeAutobindedInput(EsasSlideSelect)
